// extracted by mini-css-extract-plugin
export default {"labelMargin":"TinyEditor_labelMargin__iauvG"};